import { render, staticRenderFns } from "./SOSalesQuote.vue?vue&type=template&id=d4fe27f6&scoped=true"
import script from "./SOSalesQuote.vue?vue&type=script&lang=js"
export * from "./SOSalesQuote.vue?vue&type=script&lang=js"
import style0 from "./SOSalesQuote.vue?vue&type=style&index=0&id=d4fe27f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fe27f6",
  null
  
)

export default component.exports